import { render, staticRenderFns } from "./adminRoleList.vue?vue&type=template&id=1e26163c&"
import script from "./adminRoleList.vue?vue&type=script&lang=js&"
export * from "./adminRoleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports